import { useNavigate, useParams } from "react-router-dom";
import { Box, Typography, Button, Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import DashboardLayout from "../layouts/DashboardLayout";
import { HEADING_FONT } from "../theme/fonts";
import { COLORS } from "../theme/tokens";
import { useToast } from "../components/ToastProvider";
import ServerForm from "../components/ServerForm";

// Thin /servers/:id/edit page wrapper. The form lives in the shared ServerForm
// component (also used by the Edit Server modal on the Servers list). Kept so
// direct links / bookmarks to the edit URL still work.
function EditServer() {
  const navigate = useNavigate();
  const { id } = useParams();
  const toast = useToast();
  const goBack = () => navigate("/servers");

  return (
    <DashboardLayout>
      <Button
        onClick={goBack}
        startIcon={<ArrowBackIcon />}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          color: COLORS.muted,
          mb: 2,
          ml: -1,
          "&:hover": { background: COLORS.tile, color: COLORS.ink },
        }}
      >
        Back to Servers
      </Button>

      <Box
        sx={{
          background: `linear-gradient(135deg, ${COLORS.primaryDark} 0%, ${COLORS.primary} 60%, #60A5FA 100%)`,
          borderRadius: 3,
          p: { xs: 3, md: 4 },
          mb: 3,
          color: "#fff",
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: "10px",
              background: "rgba(255,255,255,0.18)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <DnsOutlinedIcon sx={{ fontSize: 32 }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 600,
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                opacity: 0.85,
              }}
            >
              Edit Server
            </Typography>
            <Typography
              sx={{
                fontFamily: HEADING_FONT,
                fontSize: { xs: 24, md: 32 },
                fontWeight: 700,
                letterSpacing: "-0.5px",
                lineHeight: 1.1,
              }}
            >
              Update Server
            </Typography>
            <Typography sx={{ fontSize: 13, opacity: 0.85, mt: 0.5 }}>
              Update this server's details
            </Typography>
          </Box>
        </Stack>
      </Box>

      <ServerForm
        serverId={id}
        onCancel={goBack}
        onSuccess={() => {
          toast.success("Server updated successfully");
          goBack();
        }}
      />
    </DashboardLayout>
  );
}

export default EditServer;
